:root ._dsp-flex{display:flex;}
:root ._items-stretch{align-items:stretch;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._pos-relative{position:relative;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._fd-row{flex-direction:row;}
:root ._fd-column{flex-direction:column;}
:root ._bg-backgroundM1654514607{background-color:var(--backgroundMutedBlock);}
:root ._btc-divider{border-top-color:var(--divider);}
:root ._brc-divider{border-right-color:var(--divider);}
:root ._borderBottomColor-divider{border-bottom-color:var(--divider);}
:root ._borderLeftColor-divider{border-left-color:var(--divider);}
:root ._btw-1px{border-top-width:1px;}
:root ._brw-1px{border-right-width:1px;}
:root ._borderBottomWidth-1px{border-bottom-width:1px;}
:root ._borderLeftWidth-0px{border-left-width:0px;}
:root ._items-center{align-items:center;}
:root ._justify-center{justify-content:center;}
:root ._cur-pointer{cursor:pointer;}
:root ._width-50px{width:50px;}
:root ._borderBottomStyle-solid{border-bottom-style:solid;}
:root ._borderTopStyle-solid{border-top-style:solid;}
:root ._borderLeftStyle-solid{border-left-style:solid;}
:root ._borderRightStyle-solid{border-right-style:solid;}
:root ._gap-t-space-med104641{gap:var(--t-space-medium);}
:root ._gap-t-space-sma3456{gap:var(--t-space-small);}
:root ._gap-t-space-lar3294{gap:var(--t-space-large);}